<template ref="costumerSelect">
    <div class="row">
        <div class="col-12">
            <label :for="id ? id : 'inputCostumersList'">Cliente</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fas fa-search fa-fw"></i>
                    </span>
                </div>
                <input
                    type="hidden"
                    autocomplete="off"
                    :required="required"
                    :id="id_hidden"
                    :name="name_hidden"
                    ref="costumerID"
                />
                <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    :id="id ? id : 'inputCostumersList'"
                    :name="name ? name : 'costumer_name'"
                    ref="costumers"
                    placeholder="Digite para buscar o cliente"
                    :required="required"
                    v-on:input="search"
                />
            </div>
            <div
                v-if="found"
                id="selectCostumers"
                style="background-color: #ffffff; border-radius: 3px; position: absolute; height: auto; width: 92%; z-index: 9999; box-shadow: 0px 3px 3px #ccc;"
            >
                <div class="list-group">
                    <!-- list of founded costumers -->
                    <button
                        type="button"
                        v-for="item in found"
                        :key="item.id"
                        :data-data="JSON.stringify(item)"
                        class="list-group-item list-group-item-action costumerListItem"
                    ><strong>{{item.fantasy_name}}</strong> <br/><small>{{item.address}}{{item.number ? ', ' + item.number : ''}} - {{item.city}}/{{item.uf}} - CEP: {{item.cep}}</small></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const EventBus = new Vue();
export default {
    props: {
        id_hidden: String,
        name_hidden: String,
        id: String,
        name: String,
        required: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            found: [],
            url: window.location.pathname,
            timeout: null
        };
    },
    methods: {
        generatePhonesArray(data) {
            let phones = [];
            let count = 0;
            while (count <= 3) {
                data["telefone" + count]
                    ? phones.push(data["telefone" + count])
                    : null;
                count++;
            }

            $(data).each(function(index, item) {
                phones.push({
                    id: item["id"] ? item["id"] : null,
                    name: item["name"] ? item["name"] : null,
                    phone1: item["phone1"] ? item["phone1"] : null,
                    phone2: item["phone2"] ? item["phone2"] : null
                });
            });
            return phones;
        },

        async search(event) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(async () => {
                var self = this;
                let form = event.target.form;
                let name = event.target.value;
                if (name.length >= 3) {
                    await axios
                        .get("/customer_base/searchClients", {
                            params: { search: name }
                        })
                        .then(response => {
                            console.log('search', response)
                            const costumers = response.data;
                            self.found = [];

                            costumers.forEach((item, index) => {
                                if (
                                    item.fantasy_name
                                        .toLowerCase()
                                        .includes(name.toLowerCase()) ||
                                    item.cpf_cnpj.includes(name) ||
                                    item.corporate_name
                                        .toLowerCase()
                                        .includes(name.toLowerCase())
                                ) {
                                    item["phones"] = self.generatePhonesArray(
                                        item.responsible
                                    );
                                    // self.found.push(item);
                                    self.found = [...self.found, item];
                                }
                            });

                            $(document)
                                .unbind("click")
                                .on("click", function(event) {
                                    if (
                                        $(event.target).hasClass(
                                            "costumerListItem"
                                        ) ||
                                        (event.target.id == self.$props.id) ==
                                            ""
                                            ? "inputCostumersList"
                                            : self.$props.id
                                    ) {
                                        var elem = $(event.target);
                                        var data = elem.data("data");
                                        populate(form, data);
                                        if (data) {
                                            $(`#${self.$props.id_hidden}`).val(
                                                data.id
                                            );
                                            self.$refs.costumers.value =
                                                data.fantasy_name;
                                            if (self.$props.id != "") {
                                                $(`#${self.$props.id}`)
                                                    .val(data.fantasy_name)
                                                    .data("data", data);
                                            } else {
                                                $("#inputCostumersList")
                                                    .val(data.fantasy_name)
                                                    .data("data", data);
                                            }

                                            if (
                                                self.$props.id_hidden ==
                                                "occurrencesCostumer"
                                            ) {
                                                $("#responsible_input").html(
                                                    ""
                                                );
                                                $(data.responsible).each(
                                                    function(index, item) {
                                                        var html = `<option id="${item.name}">${item.name}/${item.phone1}/${item.phone2}/${item.email}</option>`;
                                                        $(
                                                            "#responsible_input"
                                                        ).append(html);
                                                    }
                                                );
                                            }

                                            $("#inputphones_list").val("");

                                            $(
                                                "#inputphones_list option"
                                            ).remove();
                                            $(
                                                "#inputphones_list optgroup"
                                            ).remove();
                                            $("#inputphones_list").html();
                                            data.phones.forEach(element => {
                                                const html = `<option value="${element.id}">${element.name}</option><optgroup label="${element.phone1}"><optgroup label="${element.phone2}">`;
                                                $("#inputphones_list").append(
                                                    html
                                                );
                                            });

                                            $(form).trigger("form-filled");
                                        }
                                        self.found = 0;
                                    }
                                    if (self.$props.id != "") {
                                        $(`#${self.$props.id}`).data(
                                            "data",
                                            ""
                                        );
                                    } else {
                                        $("#inputCostumersList").data(
                                            "data",
                                            ""
                                        );
                                    }
                                });
                        });
                    return;
                } else {
                    self.found = [];
                }
            }, 500);
        }
    }
};
</script>
